var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"copy-url"},[_c('BaseButton',{staticClass:"copy-url__icon",attrs:{"size":"auto","aria-label":_vm.$t('words.copy_url')},nativeOn:{"click":function($event){return _vm.shareOrCopyLink()}}},[_c('fa-icon',{attrs:{"icon":_vm.faLink,"aria-hidden":"true"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }